import TextWithImage from "../TextWithImage";
import manifestImage from "../../public/img/manifest.jpg";
import { useRouter } from "next/router";
import localized from "../../locale/locales";
import SvgLogoBig from "../../svg/SvgLogoBig";

export default function SectionManifest({ setActiveVideo, openPopup }) {
  const { locale } = useRouter();
  const lang = localized[locale].aboutUs;

  return (
    <div className="pt-48 md:pt-52 md:pb-32 flex flex-col gap-20 items-center">
      <SvgLogoBig width={230} id="about-us" />
      <TextWithImage
        image={manifestImage}
        imageAlt={lang.manifest.imageAlt}
        imageRatio="aspect-[63/46]"
        onPlay={() => {
          setActiveVideo("/videos/manifest.mp4");
          openPopup();
        }}
        offsets={[0.02, -0.04]}
      >
        <p className="md:pt-24 max-w-[64ch] text-sm leading-relaxed">
          {lang.manifest.body}
        </p>
      </TextWithImage>
    </div>
  );
}
